import React from "react";
//import ReactLoading from 'react-loading';
import './Loader.css';

class Loader extends React.Component {
    constructor(){
        super();
    }
   
 
     render() {
         return <div className="container">
                   <div className="loading-inline mt-5 mb-5"><img src="/assets/images/logo/loader.gif" width="30%"/></div>
        </div>
    

 }
}
export default Loader;